import { createTheme } from '@mui/material/styles';
import { blue, pink } from '@mui/material/colors';

const lightTheme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    text: {
      primary: '#000000',
    },
    background: {
      default: '#f4f4f4',
      paper: '#ffffff',
    },
    action: {
      selected: '#e0e0e0',
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: 'white',
          width: 300,
          paddingRight: 5,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'primary.dark',
          color: 'secondary.contrastText',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 1, // Replaced theme.spacing(1) with a constant value.
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h6: {
          margin: 'auto',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          color: 'inherit',
        },
      },
    },
  },
});

export default lightTheme;
